import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ApiResponse } from '../interfaces/common.interfaces';
import { environment } from '../../environments/environment';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  ContactRequest,
  ContactResponse,
} from '../interfaces/contactos.interface';

@Injectable({
  providedIn: 'root',
})
export class ContactosService {
  private apiUrl = environment.int365_dom + '/api/v1';

  private cachedContact: Observable<ApiResponse<ContactResponse>> | null = null;
  private lastFetch: number = 0;
  private readonly CACHE_TIME = 30 * 60 * 1000; // 30 minutos en milisegundos
  private cachedLists: Observable<ApiResponse<ContactResponse>> | null = null;
  private lastListsFetch: number = 0;

  constructor(private http: HttpClient, private authService: AuthService) {}

  // Contactos
  getContact(
    request: ContactRequest
  ): Observable<ApiResponse<ContactResponse>> {
    const now = Date.now();
    if (!this.cachedContact || now - this.lastFetch > this.CACHE_TIME) {
      this.lastFetch = now;
      this.cachedContact = this.http
        .get<ApiResponse<ContactResponse>>(
          `${this.apiUrl}/Dashboard/contact`,
          this.getHttpOptions(request)
        )
        .pipe(
          map((response) => {
            try {
              return response;
            } catch (error: any) {
              console.error(
                'Error en la obtención de detalles de comisiones:',
                error
              );
              if (response.statusCode === 404) {
                throw { status: 404, error: response };
              }

              throw error;
            }
          }),
          shareReplay(1)
        );
    }
    return this.cachedContact;
  }

  // Método para forzar la actualización del caché de listas
  forceListsRefresh(
    request: ContactRequest
  ): Observable<ApiResponse<ContactResponse>> {
    this.cachedLists = null;
    this.lastListsFetch = 0;
    return this.getContact(request);
  }

  // Autenticación
  private getHttpOptions(params?: any) {
    const token = this.authService.getToken();
    if (!token) throw new Error('No token found');

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return {
      headers,
      params: params
        ? new HttpParams({ fromObject: this.formatParams(params) })
        : undefined,
    };
  }

  // Formato de parámetros
  private formatParams(params: any): { [key: string]: string } {
    const formattedParams: { [key: string]: string } = {};

    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      if (value instanceof Date) {
        formattedParams[key] = value.toISOString().split('T')[0];
      } else {
        formattedParams[key] = String(value);
      }
    });

    return formattedParams;
  }
}
